<template>
  <div >
    <!-- PC -->
    <el-dialog
      class="uploadAndTimeDialog"
      v-if="!isMobile"
      :visible.sync="visibleSync"
      :width="width"
      :show-close="false"
      :append-to-body="true"
      @close="handleClose"
      center
    >
      <template #title>
        <slot name="title"></slot>
      </template>

      <slot></slot>

      <template #footer>
        <slot name="footer"></slot>
      </template>
    </el-dialog>

    <!-- Mobile -->
    <van-popup
      class="uploadAndTimeDialog"
      v-else
      v-model="visibleSync"
      position="bottom"
      round
      :style="{ maxHeight: '85vh', height: 'auto' }"
      @close="handleClose"
      >
      <div class="mobile-dialog">
        <div class="mobile-header">
          <slot name="title"></slot>
        </div>

        <div class="mobile-content">
          <slot></slot>
        </div>

        <div class="mobile-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    width: {
      type: String,
      default: '600px'
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768
    },
    visibleSync: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.mobile-dialog {
  display: flex;
  flex-direction: column;
  max-height: 83vh;
}
.mobile-header {
  padding: 16px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}
.mobile-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  min-height: 0;
}
.mobile-footer {
  padding: 16px;
  border-top: 1px solid #eee;
}
.van-popup{
  padding: 0 !important;
}
</style>